import React, { FC, useEffect, useMemo, useState } from "react";
import LogoBanner from "../../assets/icons/logo-banner.png";
import LogoBannerTablet from "../../assets/icons/logo-banner-tablet.png";
import LogoBannerMobile from "../../assets/icons/logo-banner-mobile.png";
import { MAX_WIDTH_MOBILE, MAX_WIDTH_TABLET } from "@advapacs/common";

export const Banner: FC = () => {
  const [isTablet, setIsTablet] = useState(
    window.innerWidth <= 768 && window.innerWidth >= MAX_WIDTH_MOBILE
  );
  const [isMobile, setIsMobile] = useState(
    window.innerWidth <= MAX_WIDTH_MOBILE
  );

  const resize = () => {
    setIsTablet(
      window.innerWidth <= MAX_WIDTH_TABLET &&
        window.innerWidth >= MAX_WIDTH_MOBILE
    );
    setIsMobile(window.innerWidth < MAX_WIDTH_MOBILE);
  };

  useEffect(() => {
    window.addEventListener("resize", resize);
    return () => {
      window.removeEventListener("resize", resize);
    };
  }, []);

  const LogoDevice = useMemo(() => {
    if (isMobile) return LogoBannerMobile;
    if (isTablet) return LogoBannerTablet;
    return LogoBanner;
  }, [isTablet, isMobile]);

  return (
    <div className="banner ">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 col-sm-12 col-xs-12 banner-title d-flex">

            <p className="dashboard-text-banner m-b-lg font-weight">
              PATIENT PORTAL
            </p>
            <h1 className=" font-large m-b-sm font-weight primary-title">
              Secure Access To Your Medical History
            </h1>
            <p className="font-w-500 secondary-title">
              AdvaPACS Patient Portal enables you to securely access, view, and
              download your medical history from any device, anytime.
            </p>
          </div>
          <div className="col-lg-6 col-sm-12 col-xs-12 logo-bg d-flex">
            <img className="logo-banner" src={LogoDevice} alt="Logo Banner" />
          </div>
        </div>
      </div>
    </div>
  );
};
